<template>
  <div class="serviceInventory-container">
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="flag" theme="filled" />
          <span>服务台账</span>
        </a-space>
      </template>
      <span>服务台账包含云服务商、服务类型等信息。</span>
    </a-page-header>

    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout
        :getTableDataFunc="getTableDataFunc"
        :columnsAll="columnsAll"
        :columnDefaultSelected="columnDefaultSelected"
        :exportFunc="exportFunc"
        :toolsList="['setting', 'reload', 'leftTool', 'export', 'search']"
        :search-type-options="[
          { label: '服务类型', value: 'software_type' },
          { label: '服务名称', value: 'name' },
          { label: '服务管理员', value: 'manager' }
        ]"
        :refresh="refresh"
      >
        <template #leftTool>
          <create-button
            v-permission="{action: 'base.inventory.create', effect: 'disabled'}"
            @click="$refs.inputDrawer.show()"
          ></create-button>
        </template>
        <template #rightTool>
          <upload-button
            v-permission="{action: 'base.inventory.update'}"
            @click="$refs.uploadModal.show()"
          ></upload-button>
        </template>

        <!-- 自定义列 -->
        <template #domestic="{ slotProps }">
          <a-icon v-if="slotProps.text" style="color: #52c41a" type="check" />
          <a-icon style="color: #ff303a" v-else type="close" />
        </template>
        <template #hostService="{ slotProps }">
          <span v-if="slotProps.text">{{ slotProps.text.name }}</span>
          <span v-else>-</span>
        </template>

        <template #operation="{ slotProps }">
          <edit-button
            v-permission="{action: 'base.inventory.update', effect: 'disabled'}"
            @click="$refs.inputDrawer.show(slotProps.record.id)"
          ></edit-button>
          <delete-button
            v-permission="{action: 'base.inventory.delete', effect: 'disabled'}"
            @confirm="confirm(slotProps.record.id)"
          ></delete-button>
        </template>
      </list-layout>
    </a-card>

    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
    <upload-modal ref="uploadModal" @confirm="uploadConfirm"></upload-modal>
  </div>
</template>

<script>
import {
  getSoftwareInventoryList,
  deleteSoftwareInventory,
  exportSoftwareInventory
} from '@/api/inventory.js'
import ListLayout from '@/components/ListLayout.vue'
import CreateButton from '@/components/button/CreateButton.vue'
import InputDrawer from './modules/InputDrawer.vue'
import UploadButton from '@/components/button/UploadButton.vue'
import UploadModal from './modules/UploadModal.vue'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'

export default {
  name: 'SoftwareInventory',
  components: {
    ListLayout,
    CreateButton,
    InputDrawer,
    UploadButton,
    UploadModal,
    DeleteButton,
    EditButton
  },
  data () {
    return {
      getTableDataFunc: getSoftwareInventoryList,
      exportFunc: exportSoftwareInventory,
      refresh: false,
      columnsAll: [
        {
          dataIndex: 'host.vendor',
          title: '云服务商',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'hostVendor'
          }
        },
        {
          dataIndex: 'host.location',
          title: '云主机区域',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'hostLocation'
          }
        },
        {
          dataIndex: 'host.service',
          title: '业务系统名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'hostService'
          }
        },
        {
          dataIndex: 'host.private_ip',
          title: '云主机内网 IP',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'hostPrivateIp'
          }
        },
        {
          dataIndex: 'software_type',
          title: '服务类型',
          width: 128,
          ellipsis: true,
          scopedSlots: {
            customRender: 'softwareType'
          }
        },
        {
          dataIndex: 'name',
          title: '服务名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'port',
          title: '服务端口',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'port'
          }
        },
        {
          dataIndex: 'protocol',
          title: '服务端口协议',
          width: 140,
          scopedSlots: {
            customRender: 'protocol'
          }
        },
        {
          dataIndex: 'version',
          title: '对应版本',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'version'
          }
        },
        {
          dataIndex: 'domestic',
          title: '是否国产',
          width: 120,
          align: 'center',
          scopedSlots: {
            customRender: 'domestic'
          },
          filteredValue: null,
          filters: [
            {
              text: '是',
              value: 'true'
            },
            {
              text: '否',
              value: 'false'
            }],
          filterMultiple: false
        },
        {
          dataIndex: 'manager',
          title: '服务管理员',
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: 'manager'
          }
        },
        {
          dataIndex: 'manager_phone',
          title: '服务管理员联系方式',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'managerPhone'
          }
        },
        {
          dataIndex: 'expire_type',
          title: '到期提醒类型',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'expiresType'
          }
        },
        {
          dataIndex: 'expires_at',
          title: '到期时间',
          width: 160,
          scopedSlots: {
            customRender: 'expiresAt'
          }
        },
        {
          dataIndex: 'address',
          title: '服务地址',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'address'
          }
        },
        {
          dataIndex: 'comment',
          title: '备注',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'comment'
          }
        }
      ],
      columnDefaultSelected: [
        'host.service',
        'host.private_ip',
        'software_type',
        'name',
        'port',
        'protocol',
        'version',
        'domestic',
        'manager',
        'manager_phone',
        'expires_at',
        'address'
      ]
    }
  },
  created () {
    // this.fetch()
  },
  methods: {
    async confirm (id = '') {
      if (id) {
        await deleteSoftwareInventory(id).then(res => {
          this.$message.success(res.message)
        })
      }
      this.refresh = !this.refresh
    },
    uploadConfirm () {
      this.refresh = !this.refresh
    }
  }
}
</script>
